import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MatIconButton } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { MatToolbar } from '@angular/material/toolbar'
import { ElderThemeDirective, Interval, IsoIntervalPipe } from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { WorkCenter } from '../../../shopfloor/workcenters/work-center'
import { ControlTerminalMode } from '../../../terminals/control-terminal-mode'
import { ProductionListScope } from '../conf/prod-list-scope'
import { ProductionListComponent } from '../production-list/production-list.component'

export interface IProductionListDialogOptions {
  readonly workCenter: WorkCenter
  readonly scheduleInterval: Interval
  readonly modes: ControlTerminalMode[]
  readonly prodListConfId: string
  readonly hideToolbar: boolean
  readonly scopes: ProductionListScope[]
}

@Component({
  selector: 'app-production-list-dialog',
  templateUrl: './production-list-dialog.component.html',
  styleUrls: ['./production-list-dialog.component.scss'],
  imports: [
    MatToolbar,
    ElderThemeDirective,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    ProductionListComponent,
    ElderTranslatePipe,
    IsoIntervalPipe,
  ],
})
export class ProductionListDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly workCenter: WorkCenter
  public readonly scheduleInterval: Interval
  public readonly modes: ControlTerminalMode[]
  public readonly prodListConfId: string
  public readonly hideToolbar: boolean
  public readonly scopes: ProductionListScope[]

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<IProductionListDialogOptions>(MAT_DIALOG_DATA)
    this.workCenter = data.workCenter
    this.scheduleInterval = data.scheduleInterval
    this.modes = data.modes
    this.prodListConfId = data.prodListConfId
    this.hideToolbar = data.hideToolbar
    this.scopes = data.scopes
  }
}
